import { createFileRoute } from "@tanstack/react-router";
import { HomePage } from "@/components/pages/HomePage";
import { dictionaries } from "@/i18n/dictionaries";
import heroWebp from "@/assets/kentro-fluid-hero-4x3.webp.asset.json";
import heroAvif640 from "@/assets/kentro-fluid-hero-640.avif.asset.json";
import heroAvif960 from "@/assets/kentro-fluid-hero-960.avif.asset.json";
import heroAvif1280 from "@/assets/kentro-fluid-hero-1280.avif.asset.json";

const SITE = "https://kentro.com.br";
const OG_IMAGE = `${SITE}${heroWebp.url}`;

export const Route = createFileRoute("/feed")({
  head: () => ({
    meta: [
      { title: dictionaries.pt.home.metaTitle },
      { name: "description", content: dictionaries.pt.home.metaDesc },
      { property: "og:title", content: dictionaries.pt.home.metaTitle },
      { property: "og:description", content: dictionaries.pt.home.metaDesc },
      { property: "og:url", content: `${SITE}/` },
      { property: "og:type", content: "website" },
      { property: "og:site_name", content: "Kentro" },
      { property: "og:locale", content: "pt_BR" },

      { property: "og:image", content: OG_IMAGE },
      { property: "og:image:width", content: "1200" },
      { property: "og:image:height", content: "900" },
      {
        property: "og:image:alt",
        content: "Kentro - Plataforma de atendimento omnichannel com Chat, CRM e IA",
      },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [
      // Conteúdo idêntico à home: canonical aponta para a home para evitar duplicidade.
      { rel: "canonical", href: `${SITE}/` },
      { rel: "alternate", hrefLang: "pt-BR", href: `${SITE}/` },
      { rel: "alternate", hrefLang: "en", href: `${SITE}/en` },
      { rel: "alternate", hrefLang: "es", href: `${SITE}/es` },
      { rel: "alternate", hrefLang: "x-default", href: `${SITE}/` },

      {
        rel: "preload",
        as: "image",
        href: heroAvif960.url,
        type: "image/avif",
        imageSrcSet: `${heroAvif640.url} 640w, ${heroAvif960.url} 960w, ${heroAvif1280.url} 1280w`,
        imageSizes: "(min-width: 1024px) 55vw, 100vw",
        fetchPriority: "high",
      } as unknown as { rel: string },
      // Sem preload WebP: evita download duplicado do hero (o <picture> cobre o fallback).
    ],
  }),
  component: HomePage,
});
